import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import ClearIcon from '@mui/icons-material/Clear';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LinkIcon from '@mui/icons-material/Link';
import SearchIcon from '@mui/icons-material/Search';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import SaveIcon from '@mui/icons-material/Save';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import BusinessIcon from '@mui/icons-material/Business';
import BadgeIcon from '@mui/icons-material/Badge';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import RuleIcon from '@mui/icons-material/Rule';
import ListAltIcon from '@mui/icons-material/ListAlt';
import FactoryIcon from '@mui/icons-material/Factory';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import PublicIcon from '@mui/icons-material/Public';
import MapIcon from '@mui/icons-material/Map';
import Person2Icon from '@mui/icons-material/Person2';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ConstructionIcon from '@mui/icons-material/Construction';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import CategoryIcon from '@mui/icons-material/Category';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import EngineeringIcon from '@mui/icons-material/Engineering';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AddIcon from '@mui/icons-material/Add';
import AddTaskIcon from '@mui/icons-material/AddTask';
import SendIcon from '@mui/icons-material/Send';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import EmailIcon from '@mui/icons-material/Email';
import GridOnIcon from '@mui/icons-material/GridOn';
import TuneIcon from '@mui/icons-material/Tune';
import InsightsIcon from '@mui/icons-material/Insights';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import BlockIcon from '@mui/icons-material/Block';
import CancelIcon from '@mui/icons-material/Cancel';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockClockIcon from '@mui/icons-material/LockClock';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import PaidIcon from '@mui/icons-material/Paid';
import LanguageIcon from '@mui/icons-material/Language';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import MailLockIcon from '@mui/icons-material/MailLock';
import MoreVert from '@mui/icons-material/MoreVert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import DescriptionIcon from '@mui/icons-material/Description';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import OfflinePinIcon from '@mui/icons-material/OfflinePin';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe';
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';
import PhoneIcon from '@mui/icons-material/Phone';
import LockResetIcon from '@mui/icons-material/LockReset';
import CheckIcon from '@mui/icons-material/Check';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import FreeCancellationIcon from '@mui/icons-material/FreeCancellation';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';
import RepeatOnIcon from '@mui/icons-material/RepeatOn';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ScheduleIcon from '@mui/icons-material/Schedule';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import TodayIcon from '@mui/icons-material/Today';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import AreaChartIcon from '@mui/icons-material/AreaChart';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ForumIcon from '@mui/icons-material/Forum';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import StackedIcon from './StackedIcon';

const CustomIcons = {
  Warning: WarningAmberIcon,
  Profile: PersonOutlineIcon,
  Logout: LogoutIcon,
  ClearSearch: ClearIcon,
  HideSearch: VisibilityOffIcon,
  QuickLinks: LinkIcon,
  Search: SearchIcon,
  Back: ChevronLeftIcon,
  Menu: MenuIcon,
  Save: SaveIcon,
  Update: SaveAsIcon,
  Reset: RestartAltIcon,
  Reopen: AutorenewIcon,
  Setup: TuneIcon,
  Close: CloseIcon,
  Cancel: CloseIcon,
  Launch: LaunchIcon,
  Password: VpnKeyIcon,
  Info: InfoOutlinedIcon,
  MoreInfo: MoreVert,
  Home: HomeIcon,
  System: SettingsIcon,
  Email: EmailIcon,
  PasswordEmail: MailLockIcon,
  MFA: LockPersonIcon,
  Copy: ContentCopyIcon,
  Delete: DeleteIcon,
  View: RemoveRedEyeIcon,
  Upload: UploadFileIcon,
  UpdatePassword: LockResetIcon,
  Export: DownloadForOfflineIcon,
  Dashboard: DashboardIcon,
  Submit: SendIcon,
  ResendEmail: ForwardToInboxIcon,
  Edit: ModeEditIcon,
  FileDownload: FileDownloadOutlinedIcon,
  FilePreview: OpenInNewOutlinedIcon,

  Yes: CheckIcon,
  No: CancelIcon,

  CancelJobAction: CancelIcon,
  ScheduledJobs: PendingActionsIcon,
  Reschedule: CalendarMonthIcon,
  JobsRequiringAction: OutlinedFlagIcon,
  Reject: CancelIcon,
  ConditionallyAccept: OfflinePinIcon,
  Accept: CheckCircleIcon,
  PendingAcceptance: PendingActionsIcon,
  ConditionallyAccepted: FactCheckIcon,
  Rejected: UnsubscribeIcon,
  InterventionRequired: MarkunreadMailboxIcon,

  ApiKey: VpnKeyIcon,

  Company: MapsHomeWorkIcon,
  Companies: BusinessIcon,

  ServiceAdministrator: BadgeIcon,
  ServiceAdministrators: BadgeIcon,

  ServiceProvider: ManageAccountsIcon,
  ServiceProviders: ManageAccountsIcon,

  ServiceProviderProfileWarning: WarningAmberIcon,

  ServiceJob: WorkOutlineIcon,
  ServiceJobs: WorkOutlineIcon,

  DrivingDistance: AirportShuttleIcon,

  AvailabilitySchedular: FreeCancellationIcon,

  CutOffTime: ScheduleIcon,

  DefaultSchedule: WorkHistoryIcon,
  DefaultSchedules: CalendarMonthIcon,
  CurrentDefaultSchedule: TodayIcon,

  SpecialSchedules: DateRangeIcon,
  SpecialSchedule: EventBusyIcon,

  LiveCalendar: CalendarMonthIcon,

  ServiceJobCreate: props => (
    <StackedIcon Base={WorkOutlineIcon} overlayType="ADD" {...props} />
  ),

  ServiceJobExport: WorkHistoryIcon,

  AcceptServiceJob: props => (
    <StackedIcon
      Base={WorkOutlineIcon}
      Overlay={CheckCircleIcon}
      overlayColor="success.main"
      {...props}
    />
  ),

  RescheduleServiceJob: props => (
    <StackedIcon Base={WorkOutlineIcon} Overlay={WatchLaterIcon} {...props} />
  ),

  ConditionllyAcceptServiceJob: props => (
    <StackedIcon
      Base={WorkOutlineIcon}
      Overlay={FactCheckIcon}
      overlayColor="success.main"
      {...props}
    />
  ),

  RejectServiceJob: props => (
    <StackedIcon
      Base={WorkOutlineIcon}
      Overlay={CancelIcon}
      overlayColor="error.main"
      {...props}
    />
  ),

  CancelServiceJob: props => (
    <StackedIcon
      Base={WorkOutlineIcon}
      Overlay={CancelIcon}
      overlayColor="error.main"
      {...props}
    />
  ),

  AssignServiceJob: props => (
    <StackedIcon
      Base={WorkOutlineIcon}
      Overlay={AccountCircleIcon}
      overlayColor="success.main"
      {...props}
    />
  ),

  Claim: ContentPasteIcon,
  Claims: ContentPasteIcon,

  ClaimRules: RuleIcon,
  ClaimRule: RuleIcon,

  ClaimForms: ListAltIcon,
  ClaimForm: ListAltIcon,

  ClaimPaymentExports: PaidIcon,
  ClaimPaymentExport: PaidIcon,

  Invoices: RequestQuoteIcon,
  Invoice: RequestQuoteIcon,

  Issue: ReportProblemIcon,
  IssueDetail: AssignmentLateIcon,
  Issues: ListAltIcon,
  IssueTracking: AssignmentLateIcon,
  IssueCreate: AddTaskIcon,
  IssueExport: props => (
    <StackedIcon Base={AssignmentLateIcon} overlayType="EXPORT" {...props} />
  ),
  IssueDelete: props => (
    <StackedIcon
      Base={AssignmentLateIcon}
      Overlay={DeleteIcon}
      overlayColor="error.main"
      {...props}
    />
  ),
  IssueResolve: props => (
    <StackedIcon
      Base={AssignmentLateIcon}
      Overlay={CheckCircleIcon}
      overlayColor="success.main"
      {...props}
    />
  ),
  IssueReopen: props => (
    <StackedIcon Base={AssignmentLateIcon} Overlay={AutorenewIcon} {...props} />
  ),
  ISSUE_STATUS_ALL: ListAltIcon,
  ISSUE_STATUS_BACKLOG: PendingActionsIcon,
  ISSUE_STATUS_OPEN: AssignmentLateIcon,
  ISSUE_STATUS_NEEDS_INFO: HelpOutlineIcon,
  ISSUE_STATUS_WAITING_FOR_REPORTER: HourglassEmptyIcon,
  ISSUE_STATUS_IN_PROGRESS: PlayCircleIcon,
  ISSUE_STATUS_BLOCKED: BlockIcon,
  ISSUE_STATUS_ON_HOLD: LockClockIcon,
  ISSUE_STATUS_IN_REVIEW: FactCheckIcon,
  ISSUE_STATUS_RESOLVED: CheckCircleIcon,
  ISSUE_STATUS_CLOSED: TaskAltIcon,
  ISSUE_STATUS_DUPLICATE: ContentCopyIcon,
  ISSUE_STATUS_CANCELLED: CancelIcon,

  Client: Person2Icon,
  Clients: Person2Icon,

  Industry: FactoryIcon,
  Industries: FactoryIcon,

  ServiceJobForm: TextSnippetIcon,
  ServiceJobForms: TextSnippetIcon,

  Country: PublicIcon,
  Countries: PublicIcon,

  ServiceSite: MapIcon,
  ServiceSites: MapIcon,

  ServiceAdministratorClients: Person2Icon,
  ServiceAdministratorClient: Person2Icon,

  ServiceAdministratorWarrantyType: ReceiptLongIcon,
  ServiceAdministratorWarrantyTypes: ReceiptLongIcon,

  ServiceAdministratorRepairSeverity: ConstructionIcon,
  ServiceAdministratorRepairSeverities: ConstructionIcon,

  ServiceAdministratorServiceType: BuildCircleIcon,
  ServiceAdministratorServiceTypes: BuildCircleIcon,

  ServiceAdministratorProductLines: CategoryIcon,
  ServiceAdministratorProductLine: CategoryIcon,

  ServiceProviderContact: ContactMailIcon,
  ServiceProviderContacts: ContactMailIcon,

  ServiceProviderLocation: LocationOnIcon,
  ServiceProviderLocations: LocationOnIcon,

  ServiceProviderSingleLocation: LocationPinIcon,

  ServiceProviderAddress: AlternateEmailIcon,
  ServiceProviderAddresses: AlternateEmailIcon,

  ServiceProviderIndustries: WarehouseIcon,
  ServiceProviderIndustry: WarehouseIcon,

  Rules: RuleIcon,
  Rule: RuleIcon,

  Workflow: AccountTreeIcon,
  Workflows: AccountTreeIcon,
  Flow: AccountTreeIcon,

  Next: KeyboardArrowRightIcon,
  Previous: KeyboardArrowLeftIcon,

  Skill: EngineeringIcon,
  Skills: EngineeringIcon,

  CompanyInfo: PermIdentityIcon,

  MoveLeft: KeyboardArrowLeftIcon,
  MoveRight: KeyboardArrowRightIcon,
  MoveAllLeft: KeyboardDoubleArrowLeftIcon,
  MoveAllRight: KeyboardDoubleArrowRightIcon,

  SystemSetting: SettingsSuggestIcon,
  SystemSettings: SettingsSuggestIcon,

  Add: AddIcon,

  Dispatch: SendIcon,
  DispatchNotSent: CancelScheduleSendIcon,
  DispatchAlternateTime: ScheduleSendIcon,

  Map: MapIcon,

  User: PersonIcon,
  Users: PeopleIcon,

  Message: EmailIcon,

  LaborMatrix: GridOnIcon,
  LaborMatrices: GridOnIcon,

  Brand: CategoryIcon,
  Brands: CategoryIcon,

  Performance: InsightsIcon,

  Contact: LocalPostOfficeIcon,

  Location: LocationOnIcon,

  NotificationPreferences: EditNotificationsIcon,

  JOB_STATUS_INCOMPLETE: HourglassEmptyIcon,
  JOB_STATUS_PENDING_ACCEPTANCE: HourglassTopIcon,
  JOB_STATUS_DISPATCH_PENDING: LocalShippingIcon,
  JOB_STATUS_CANCELED: CancelIcon,
  JOB_STATUS_ACTIVE: PlayCircleIcon,
  JOB_STATUS_COMPLETE: CheckCircleIcon,
  JOB_STATUS_SERVICE_PENDING: BuildCircleIcon,
  JOB_STATUS_PENDING_PREAUTHORIZATION: LockClockIcon,
  JOB_STATUS_PENDING_PREAUTHORIZATION_REQUEST: PendingActionsIcon,
  JOB_STATUS_INTERVENTION_REQUIRED: ReportProblemIcon,
  JOB_STATUS_UNKNOWN: HelpOutlineIcon,

  DISPATCH_STATUS_PENDING_ACCEPTANCE: HourglassTopIcon,
  DISPATCH_STATUS_ASSIGNED: AssignmentIndIcon,
  DISPATCH_STATUS_INTERVENTION_REQUIRED: ReportProblemIcon,
  DISPATCH_STATUS_REVOKED: BlockIcon,
  DISPATCH_STATUS_CANCELED: CancelIcon,

  DISPATCH_EVENT_STATUS_PENDING_ACCEPTANCE: HourglassTopIcon,
  DISPATCH_EVENT_STATUS_ACCEPTED: CheckCircleIcon,
  DISPATCH_EVENT_STATUS_REJECTED: CancelIcon,
  DISPATCH_EVENT_STATUS_ACCEPTED_WITH_CONDITIONS: PendingActionsIcon,
  DISPATCH_EVENT_STATUS_REVOKED: BlockIcon,
  DISPATCH_EVENT_STATUS_SCHEDULED: EventAvailableIcon,
  DISPATCH_EVENT_STATUS_ASSIGNED: AssignmentIndIcon,

  CLAIM_STATUS_INCOMPLETE: AssignmentLateIcon,
  CLAIM_STATUS_CANCELED: CancelIcon,
  CLAIM_STATUS_PENDING_ADMIN_REVIEW: HourglassEmptyIcon,
  CLAIM_STATUS_PENDING_UNDERWRITER_REVIEW: HourglassEmptyIcon,
  CLAIM_STATUS_PENDING_UNDERWRITER_RECEIPT: HourglassEmptyIcon,
  CLAIM_STATUS_APPROVED: CheckCircleIcon,
  CLAIM_STATUS_APPROVED_OVERRIDE: TaskAltIcon,
  CLAIM_STATUS_REJECTED: DoDisturbIcon,
  CLAIM_STATUS_REJECTED_OVERRIDE: CancelIcon,
  CLAIM_STATUS_CORRECTED: PublishedWithChangesIcon,
  CLAIM_STATUS_CORRECTION_DRAFT: EditNoteIcon,
  CLAIM_STATUS_TRANSFERRED: AutorenewIcon,
  CLAIM_STATUS_PAID: PaidIcon,

  Help: HelpOutlineIcon,
  Public: LanguageIcon,

  Note: DescriptionIcon,
  Notes: DescriptionIcon,

  Conversation: QuestionAnswerIcon,
  Conversations: QuestionAnswerIcon,
  SPActive: PersonIcon,
  SPInActive: PersonOffIcon,

  FormChanged: EditOutlinedIcon,
  Phone: PhoneIcon,
  OutsideServiceArea: WrongLocationIcon,
  SkillMismatch: WarningAmberIcon,
  ReworkLocation: RepeatOnIcon,

  Alerts: NotificationsIcon,
  CustomerInteraction: RecordVoiceOverIcon,

  ServiceArea: AreaChartIcon,

  Support: ForumIcon,

  RequestsAndFeedback: RateReviewIcon,
};

export default CustomIcons;
